<div class="loading-wrapper" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="overview-container">

  <mat-card *ngFor="let report of reports; let i = index" class="graph-card">

    <!--button (click)="onDeleteReport(report)" style="
        position: absolute;
        top: 0;
        right: 0;
        background: rgb(244, 67, 54);
        color: white;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        font-size: 12px;
        padding: 0;
        cursor: pointer;
      ">
      x
    </button-->

    <mat-card-header class="graph-card-header">
      <mat-card-title>
        {{ report.rep_title }}

      </mat-card-title>
      <mat-card-subtitle>
        <div style="display: flex; gap: 0.5rem; align-items: center;">
          <span *ngIf="report.rep_filter.has('updatedAt[$gte]')">
            From {{ formatDate(report.rep_filter.get('updatedAt[$gte]') || '') }}
          </span>
          <span *ngIf="report.rep_filter.has('updatedAt[$lte]')">
            to {{ formatDate(report.rep_filter.get('updatedAt[$lte]') || '') }}
          </span>
        </div>

      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="graph-card-content">
      <app-reporting-graph [report]="report"></app-reporting-graph>
    </mat-card-content>
    <mat-card-content>

      <mat-chip-set class="info-chips">
        <div *ngFor="let rep_key of report.rep_filter.keys()">
          <mat-chip *ngIf="!rep_key.toLowerCase().includes('updated')">


            {{ getFilterLabel(rep_key) }}: <strong> {{ report.rep_filter.getAll(rep_key)?.join(', ') }} </strong>
          </mat-chip>
        </div>
      </mat-chip-set>
    </mat-card-content>





    <mat-card-footer class="graph-card-footer">

      <mat-card-actions class="reporting-actions">

        <button mat-icon-button matTooltip="Dublicate report"
          (click)="onDuplicateReport(report)"><mat-icon>control_point_duplicate</mat-icon></button>
        <button mat-icon-button diameter="14" matTooltip="Download data"
          (click)="onExportReport(report)"><mat-icon>save_alt</mat-icon></button>
        <button mat-icon-button matTooltip="Delete report"
          (click)="onDeleteReport(report)"><mat-icon>delete</mat-icon></button>
        <button mat-icon-button matTooltip="Edit" color="primary"
          (click)="onAddReport(report)"><mat-icon>edit</mat-icon></button>
      </mat-card-actions>
    </mat-card-footer>

  </mat-card>

  <mat-card (click)="onAddReport()" class="add-graph-card" *ngIf="!isLoading">
    <button mat-fab color="primary"><mat-icon>add</mat-icon></button>
  </mat-card>
</div>